var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CpTextEditor',{attrs:{"text":_vm.text,"placeholder":"Write a comment...","withBackground":false,"primaryBtnType":false,"loadingSend":_vm.loading,"isMessagingToRep":_vm.sendToRep},on:{"sendMessage":_vm.sendMessage}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }